const fancyTextBox01 = [
  {
    icon: { class: 'line-icon-Archery-2' },
    titleKey: 'fancy_text_box.strategy.title',
    descriptionKey: 'fancy_text_box.strategy.description',
  },
  {
    icon: { class: 'line-icon-Glasses-3' },
    titleKey: 'fancy_text_box.research.title',
    descriptionKey: 'fancy_text_box.research.description',
  },
  {
    icon: { class: 'line-icon-Knight' },
    titleKey: 'fancy_text_box.planning.title',
    descriptionKey: 'fancy_text_box.planning.description',
  },
  {
    icon: { class: 'line-icon-Coins-2' },
    titleKey: 'fancy_text_box.assurance.title',
    descriptionKey: 'fancy_text_box.assurance.description',
  },
  {
    icon: { class: 'line-icon-Bar-Chart2' },
    titleKey: 'fancy_text_box.analysts.title',
    descriptionKey: 'fancy_text_box.analysts.description',
  },
  {
    icon: { class: 'line-icon-Coins' },
    titleKey: 'fancy_text_box.investment.title',
    descriptionKey: 'fancy_text_box.investment.description',
  },
];

const fancyTextBox02 = [
  {
    icon: { class: 'line-icon-Mail-Read text-basecolor' },
    titleKey: 'fancy_text_box.contact_help.title',
    descriptionKey: 'fancy_text_box.contact_help.email',
    linkTitleKey: 'fancy_text_box.contact_help.link_title',
    link: 'mailto:contact@jaafaracademy.com',
  },
  {
    icon: { class: 'line-icon-Phone-2 text-basecolor' },
    titleKey: 'fancy_text_box.contact_us.title',
    descriptionKey: 'fancy_text_box.contact_us.phone',
    linkTitleKey: 'fancy_text_box.contact_us.link_title',
    link: '#',
  },
  {
    icon: { class: 'fas fa-map-marked-alt text-basecolor' },
    titleKey: 'fancy_text_box.headquarters.title',
    descriptionKey: 'fancy_text_box.headquarters.description',
    linkTitleKey: 'fancy_text_box.headquarters.link_title',
    link: '#',
  },
];

export default { fancyTextBox01, fancyTextBox02 };